import { AccessibleProduct } from "@dune/types";
import { Checkbox, Chip } from "@dune/ui";
import { ColumnDef } from "@tanstack/react-table";

export const agreementProductsColumns: ColumnDef<AccessibleProduct>[] = [
	{
		accessorKey: "name",
		header: "Produit",
		cell: ({ row }) => row.original.name,
	},
	{
		accessorKey: "authorized",
		header: "Oui/Non",
		cell: ({ row }) => {
			return (
				<>
					{row.original.authorized && <Chip color="green" label="Oui" />}
					{!row.original.authorized && <Chip color="red" label="Non" />}
				</>
			);
		},
	},
	{
		accessorKey: "commission",
		header: "Commission (en %)",
		cell: ({ row }) => {
			return row.original.commission;
		},
	},
	{
		accessorKey: "minCommission",
		header: "Commission minimum (en €)",
		cell: ({ row }) => {
			return row.original.minCommission;
		},
	},
	{
		accessorKey: "isReunionDepartmentAuthorized",
		header: "Réunion (DO)",
		cell: ({ row }) => {
			return <Checkbox checked={row.original.isReunionDepartmentAuthorized} />;
		},
	},
];
